export const actionTypes = {
  SET_PRODUCTS: "SET_PRODUCTS",
  SELECTED_PRODUCTS: "SELECTED_PRODUCTS",
  REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",

  ADD_TO_CART: "ADD_TO_CART",
  DEL_ITEM: "DEL_ITEM",
  ADD_QTY: "ADD_QTY",
  ADD_SIZE: "ADD_SIZE",
  REMOVE_ALL: "REMOVE_ALL",

  SIGN_UP: "SIGN_UP",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
};
